import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QuickreplyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"quickreply"}/>
}
